import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers(['root', 'item', 'button', 'title', 'icon', 'panel', 'content']);

/**
 * @typedef {import('@chakra-ui/styled-system').PartsStyleInterpolation<{
 *  keys: ("root" | "item" | "button" | "title" | "icon" | "panel" | "content")[]
 * }>} AccordionStyles
 */
export const accordionStyles = helpers.defineMultiStyleConfig({
  /**
   * @param {Object} args - Component arguments
   * @param {Contentful.Accordion} args.component - Accordion component data
   * @param {boolean} [args.isComplete] - Whether component has all fields
   * @param {boolean} [args.isFetching] - Whether additional data is being fetched
   *
   * @returns {AccordionStyles} - Component styles
   */
  baseStyle({component, isComplete, isFetching}) {
    return {
      root: {
        width: 'full',
      },
      item: {
        borderBottom: '1px solid',
        borderColor: 'brandColors.greyscale10',
        _first: {
          borderTop: '1px solid',
          borderColor: 'brandColors.greyscale10',
        },
      },
      button: {
        width: 'full',
        justifyContent: 'space-between',
        paddingY: {base: 4, lg: 5}, // 16px mobile, 20px desktop
        paddingX: 0,
        _hover: {
          backgroundColor: 'transparent',
        },
        _focus: {
          boxShadow: 'none',
        },
      },
      title: {
        flex: 1,
        textAlign: 'left',
        fontFamily: 'heading',
        fontSize: 'xl', // 20px for all breakpoints
        fontWeight: 'normal',
        lineHeight: '1.5',
        color: 'black',
      },
      icon: {
        flexShrink: 0,
        width: '16px',
        height: '16px',
        marginLeft: 4, // 16px
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'brandColors.greyscale',
      },
      panel: {
        paddingTop: 0,
        paddingBottom: {base: 4, lg: 5}, // 16px mobile, 20px desktop
        paddingX: 0,
      },
      content: {
        fontSize: 'md', // 16px
        color: 'black',
      },
    };
  },
});
